import {notificationColors, notificationContext, notificationStatus, notificationType} from '@/enums';
import {i18nService} from '@/services/i18n.service';
import {store} from '@/store';
import {NOTIFICATIONS_SEND, NOTIFICATIONS_SEND_TOAST} from '@/store/modules/notifications/types';
import * as _ from 'lodash';

export interface AlertMessage {
  id?: number;
  status: number;
  type?: 'warning' | 'error' | 'success' | string;
  icon?: string;
  title?: string;
  message?: string;
  data?: {
    id: number;
    filename: string;
    referenceDate: Date;
    status: number;
  } | any;
  timeout?: number;
}

export interface INotificationService {
  sendAlert(message: AlertMessage): void;

  sendNotification(message: AlertMessage): void;

  sendToast(message: AlertMessage | string): void;

  getNotificationContext(context: number): string;

  getNotificationType(type: number): string;

  getNotificationStatus(status: number): string;

  getNotificationIcon(status: number): string;

  getNotificationColor(status: number): string;
}

export class NotificationService implements INotificationService {
  sendAlert(message: AlertMessage) {
    const msg: AlertMessage = {
      id: _.random(99999, 99999999),
      type: this.getNotificationColor(message.status),
      status: message.status,
      icon: '',
      title: i18nService.i18n(`Upload.${_.capitalize(this.getNotificationStatus(message.status))}`),
      message: i18nService.i18n(`Upload.Messages.${_.capitalize(this.getNotificationStatus(message.status))}`, message.data),
      data: message.data
    };

    if (message.status === notificationStatus.error) {
      this.sendNotification(msg);
    } else {
      this.sendToast(msg);
    }
  }

  sendNotification(message: AlertMessage) {
    store.dispatch(NOTIFICATIONS_SEND, message);
  }

  sendToast(message: AlertMessage | string) {
    store.dispatch(NOTIFICATIONS_SEND_TOAST, message);
  }

  getNotificationContext(value: number): string {
    return notificationContext[value];
  }

  getNotificationType(value: number): string {
    return notificationType[value];
  }

  getNotificationStatus(value: number): string {
    return notificationStatus[value];
  }

  getNotificationIcon(value: number): string {
    switch (value) {
      case notificationType.error:
        return 'bug red';
      case notificationType.success:
        return 'check circle green';
      case notificationType.alert:
        return 'warning sign orange';
      default:
        return 'announcement blue';
    }
  }

  getNotificationColor(value: number): string {
    return notificationColors[value];
  }
}

export const notificationService = new NotificationService();
